import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { loadProjects } from '../../ducks/projects'
import { loadCustomers } from '../../ducks/customers'
import { loadCredentials } from '../../ducks/credentials'

function mapStateToProps (state, ownProps) { // eslint-disable-line no-unused-vars
  return {
    projectsFetching: state.projects.fetching,
    projectsFetched: state.projects.fetched,
    projects: state.projects.list,
    customersFetching: state.customers.fetching,
    customersFetched: state.customers.fetched,
    customers: state.customers.list,
    credentialsFetching: state.credentials.fetching,
    credentialsFetched: state.credentials.fetched,
    credentials: state.credentials.list
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    loadProjects,
    loadCustomers,
    loadCredentials
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/dashboard/index.js